















































import Vue, { PropType } from 'vue';
import { Creative } from '@/types';

export default Vue.extend({
  name: 'ViewCreativeModal',
  props: {
    creative: {
      type: Object as PropType<Creative>,
    },
  },
  methods: {
    modalPreviewCreativeClose() {
      this.$emit('close');
    },
  },
  data: function () {
    return {};
  },
});
